// extracted by mini-css-extract-plugin
module.exports = {"pendingbox":"TxPendingView_pendingbox__2d6JL","icon":"TxPendingView_icon__2Kzbp","text":"TxPendingView_text__2oB8r"};